<template>
  <el-dialog :title="$t('productGroupManage.edit')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="editProductGroupInfo" label-width="120px">
      <el-form-item :label="$t('productGroupManage.productDesc')">
        <el-input v-model="editProductGroupInfo.prodDesc" type="textarea"
          :placeholder="$t('productGroupManage.productDescRequired')" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.groupPeople')">
        <el-input v-model="editProductGroupInfo.userCount" type="number"
          :placeholder="$t('productGroupManage.groupPeopleRequired')" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.groupPrice')">
        <el-input v-model="editProductGroupInfo.groupPrice"
          :placeholder="$t('productGroupManage.groupPriceRequired')" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.status')">
        <el-select v-model="editProductGroupInfo.state" :placeholder="$t('productGroupManage.statusRequired')"
          style="width:100%">
          <el-option disabled :value="''" :label="$t('productGroupManage.statusRequired')" />
          <el-option :label="$t('productGroupManage.enable')" value="1001" />
          <el-option :label="$t('productGroupManage.disable')" value="2002" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.startTime')">
        <el-date-picker v-model="editProductGroupInfo.startTime" type="datetime"
          :placeholder="$t('productGroupManage.startTimeRequired')" value-format="yyyy-MM-dd HH:mm:ss"
          style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.endTime')">
        <el-date-picker v-model="editProductGroupInfo.endTime" type="datetime"
          :placeholder="$t('productGroupManage.endTimeRequired')" value-format="yyyy-MM-dd HH:mm:ss"
          style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.isRebate')">
        <el-select v-model="editProductGroupInfo.rebateFlag" :placeholder="$t('productGroupManage.isRebateRequired')"
          style="width:100%">
          <el-option disabled :value="''" :label="$t('productGroupManage.isRebateRequired')" />
          <el-option :label="$t('productGroupManage.yes')" value="Y" />
          <el-option :label="$t('productGroupManage.no')" value="N" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="editProductGroupInfo.rebateFlag === 'Y'" :label="$t('productGroupManage.leaderRebate')">
        <el-row :gutter="20">
          <el-col :span="4">
            <span>{{ $t('productGroupManage.commercialPrice') }}</span>
          </el-col>
          <el-col :span="4">
            <el-input v-model="editProductGroupInfo.rebate" type="number"
              :placeholder="$t('productGroupManage.rebateNumber')" />
          </el-col>
          <el-col :span="4">
            <span>% {{ $t('productGroupManage.rebate') }}</span>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="editProductGroup">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateProductGroup } from '@/api/group/productGroupApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditProductGroup',
  data() {
    return {
      dialogVisible: false,
      editProductGroupInfo: {
        groupId: '',
        prodName: '',
        productId: '',
        valueId: '',
        prodDesc: '',
        userCount: '',
        groupPrice: '',
        state: '',
        startTime: '',
        endTime: '',
        rebateFlag: '',
        rebate: ''
      }
    }
  },
  methods: {
    open(row) {
      console.log(row)
      this.dialogVisible = true
      this.editProductGroupInfo = { ...row }
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.editProductGroupInfo = {
        groupId: '',
        prodName: '',
        productId: '',
        valueId: '',
        prodDesc: '',
        userCount: '',
        groupPrice: '',
        state: '',
        startTime: '',
        endTime: '',
        rebateFlag: '',
        rebate: ''
      }
    },
    async editProductGroup() {
      try {
        this.editProductGroupInfo.shopId = getShopId()
        await updateProductGroup(this.editProductGroupInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>